import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Role} from "../../../identite/shared/classes/role";
import { TRANSLATE } from '../../classes/translatable';
import {debounceTime} from "rxjs/operators";
import {IdentiteService} from "../../../identite/shared/services/identite.service";
import {AbstractControl, FormControl} from '@angular/forms';

@Component({
  selector: 'app-search-role-by-name',
  templateUrl: './search-role-by-name.component.html',
  styleUrls: ['./search-role-by-name.component.css']
})
export class SearchRoleByNameComponent implements OnInit {
  @Input()    aclRoleIdToFind: string = null;
  @Input()    label = "";
  @Input()    unsetTooltip = TRANSLATE('Associer un autre Role');

  @Input()    roleSearchTerm: AbstractControl = new FormControl();

  @Input()    isLocked      = false;
  @Input()    isDeleteAble  = true;

  @Output()   SelectedRoleEvent = new EventEmitter<Role>();

  public    selectedRole: Role = new Role();
  public    listRole: Role[];
  constructor(private identiteService: IdentiteService) { }

  ngOnInit() {
    this.selectedRole.identite.computed_name = "";
    this.initSearch();
  }

  initSearch() {
    this.roleSearchTerm.valueChanges
        .pipe(
            debounceTime(350),
        )
        .subscribe(term => {
          if (term.length < 3)
            return;
          this.listRole = [];
          this.identiteService.getIdentitesByTerm(term, this.aclRoleIdToFind)
              .subscribe(result => {
                if (result.status === 200) {
                  result.data.forEach(element => {
                    this.listRole.push(new Role(element));
                  });
                }
              });
        });
  }

  onSelect(role: Role) {
    this.selectedRole = role;
    this.SelectedRoleEvent.emit(role);
    this.roleSearchTerm.setValue(role.identite.computed_name);
    this.isLocked = true;
  }

  unsetRole() {
    if (!this.isDeleteAble)
      return;
    this.isLocked = false;
    this.roleSearchTerm.setValue('');
    this.SelectedRoleEvent.emit(null);
  }

  reset() {
    this.unsetRole();
  }
}
